export type MarketplaceTourKind = 'selfTour' | 'tourWithAgent';

export type MarketplaceTourAvailability = {
  canSelfTour: boolean | null;
  displayBadge: string;
  hasCurrentAvailability: boolean;
};

export function determineMarketplaceTourKind({
  canSelfTour,
  displayBadge,
  hasCurrentAvailability,
}: MarketplaceTourAvailability): MarketplaceTourKind | null {
  if (!hasCurrentAvailability) return null;
  if (displayBadge === 'ON_THE_MARKET') return 'selfTour';
  if (displayBadge === 'TRADITIONAL' || (displayBadge === 'UNKNOWN' && !canSelfTour)) {
    return 'tourWithAgent';
  }
  return null;
}
